// The last clients a user opened, for the search box: clicking into it lists
// them before anything is typed, so getting back to a client never needs
// their name typed again (2026-10-05).
//
// Only record ids are kept, per user, in this browser — never a name — and
// the names are fetched when the list is shown. Storage can be missing or
// refuse (a private window, blocked site data), so every read and write is
// guarded and an empty list is the fallback.
import { supabase } from './supabase';

const MAX = 5;
const key = (userId) => `caera.recentClients.${userId || 'anon'}`;

export function recentClientIds(userId) {
  try {
    const v = JSON.parse(window.localStorage.getItem(key(userId)) || '[]');
    return Array.isArray(v) ? v.filter((x) => typeof x === 'string').slice(0, MAX) : [];
  } catch { return []; }
}

export function rememberClient(userId, clientId) {
  if (!clientId) return;
  try {
    const next = [clientId, ...recentClientIds(userId).filter((x) => x !== clientId)].slice(0, MAX);
    window.localStorage.setItem(key(userId), JSON.stringify(next));
  } catch { /* storage unavailable: nothing to remember */ }
}

// The rows to show, most recent first; clients since removed drop out.
export async function loadRecentClients(userId) {
  const ids = recentClientIds(userId);
  if (!ids.length) return [];
  const { data, error } = await supabase.from('clients').select('id, client_id, first_name, last_name, current_status').in('id', ids);
  if (error || !data) return [];
  const byId = new Map(data.map((r) => [r.id, r]));
  return ids.map((id) => byId.get(id)).filter(Boolean);
}
